export default [
    {
        path: "/students",
        name: "my_students",
        component: () => import(/* webpackChunkName: "my_students" */ "../views/student/StudentList.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/student/view/:id",
        name: "parent_view_student",
        component: () => import(/* webpackChunkName: "parent_view_student" */ "../views/student/ViewStudent.vue"),
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: "/student/add",
        name: "parent_add_student",
        component: () => import(/* webpackChunkName: "parent_add_student" */ "../views/student/StudentForm.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/student/edit/:id",
        name: "parent_edit_student",
        component: () => import(/* webpackChunkName: "parent_edit_student" */ "../views/student/StudentForm.vue"),
        meta: { requiresAuth: true },
        props: true
    },
    {
        path: "/student/:id/settings",
        name: "student_settings",
        component: () => import(/* webpackChunkName: "student_settings" */ "../views/student/Settings.vue"),
        props: true,
        meta: { requiresAuth: true }
    },
]